/* eslint-disable import/prefer-default-export */
// Utilities to normalize HTTP errors (especially Axios errors) across the app

function extractMessageFromData(data) {
  if (!data) return undefined;
  if (typeof data === 'string') return data;

  // Common API shapes
  const candidateKeys = ['message', 'error', 'detail', 'Message', 'title', 'description'];
  for (let i = 0; i < candidateKeys.length; i += 1) {
    const key = candidateKeys[i];
    const value = data[key];
    if (typeof value === 'string' && value.trim()) return value;
    if (Array.isArray(value) && value.length > 0) {
      const first = value[0];
      if (typeof first === 'string' && first.trim()) return first;
      if (first && typeof first.message === 'string') return first.message;
    }
  }

  // Arrays of errors
  if (Array.isArray(data)) {
    const first = data[0];
    if (typeof first === 'string' && first.trim()) return first;
    if (first && typeof first.message === 'string') return first.message;
  }

  // RFC7807/problem+json or generic error objects
  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const first = data.errors[0];
    if (typeof first === 'string' && first.trim()) return first;
    if (first && typeof first.message === 'string') return first.message;
  }

  // ModelState-like objects: { Field: ["msg1", ...], OtherField: ["msg2"] }
  if (typeof data === 'object' && data !== null) {
    const objectKeys = Object.keys(data);
    for (let i = 0; i < objectKeys.length; i += 1) {
      const value = data[objectKeys[i]];
      if (typeof value === 'string' && value.trim()) return value;
      if (Array.isArray(value) && value.length > 0) {
        const first = value[0];
        if (typeof first === 'string' && first.trim()) return first;
        if (first && typeof first.message === 'string') return first.message;
      }
    }
  }

  return undefined;
}

export function parseHttpError(error) {
  if (!error) return { status: undefined, message: undefined, data: undefined, isAxiosError: false };

  const response = error.response || null;
  const status = (response && response.status) || error.status;
  const data = (response && response.data) || error.data;
  const derivedMessage = extractMessageFromData(data);
  const message = derivedMessage || error.message;
  const isAxiosError = Boolean(response) || Boolean(error.isAxiosError);

  return { status, message, data, isAxiosError };
}
